import {CreditText} from "../models/CreditText";
import {makeAutoObservable} from "mobx";
import agent from "../api/agent";

export default class CreditTextsStore {
    creditTexts: CreditText[] = [];
    isLoading = true;
    creditTextIsLoading: Map<number, boolean> = new Map();

    constructor() {
        makeAutoObservable(this);
        this.findAll().then(() => {
            this.creditTexts.forEach(cr => {
                this.setCreditTextIsLoading(cr.id, false);
                this.setIsLoading(false);
            })
        })
    }

    findAll = async () => {
        this.setIsLoading(true);
        const creditTexts: CreditText[] = await agent.CreditTexts.findAll();
        if(creditTexts) this.setCreditTexts(creditTexts);
        this.setIsLoading(false);
    }

    create = async (language: 'en' | 'fr' | 'ge' | 'ru') => {
        this.setIsLoading(true);
        //Because in case you're updating text and then click on create, so that onBlur happens before create
        setTimeout(async () => {
            const newCreditText = await agent.CreditTexts.create(language);
            if(newCreditText) this.setCreditTexts([...this.creditTexts, newCreditText])
            this.setCreditTextIsLoading(newCreditText.id, false);
            this.setIsLoading(false);
        }, 500)
    }

    update = async (creditText: CreditText) => {
        this.setCreditTextIsLoading(creditText.id, true);
        const updated = await agent.CreditTexts.update(creditText);
        if(updated) this.setCreditTexts(updated);
        this.setCreditTextIsLoading(creditText.id, false);
    }

    updateOrder = async (creditText: CreditText, delta: number) => {
        this.setIsLoading(true);
        const newOrder = creditText.order + delta;
        if(newOrder < 1 || newOrder > this.creditTexts.length) return;
        const otherCr = this.creditTexts.find(cr => cr.order === newOrder);
        if(!otherCr) return;
        creditText.order = newOrder;
        await this.update(creditText);
        this.setIsLoading(false);
    }

    del = async (id: number) => {
        this.setCreditTextIsLoading(id, true);
        const allCts = await agent.CreditTexts.del(id);
        if(allCts) this.setCreditTexts(allCts);
        this.creditTextIsLoading.delete(id);
    }

    setCreditTexts = (creditTexts: CreditText[]) => {
        this.creditTexts = creditTexts.sort((a,b) => a.order > b.order ? 1 : 0);
    }

    setCreditText(creditText: CreditText) {
        this.creditTexts = this.creditTexts
            .map(cr => cr.id === creditText.id ? creditText : cr)
            .sort((a,b) => a.order > b.order ? 1 : 0);
    }

    setCreditTextIsLoading = (id: number, isLoading: boolean) => {
        this.creditTextIsLoading.set(id, isLoading);
    }

    isCreditTextLoading = (id: number): boolean => {
        return (!!this.creditTextIsLoading.get(id));
    }

    setIsLoading = (isLoading: boolean) => { this.isLoading = isLoading; }

    toString = (language: 'en' | 'fr' | 'ge' | 'ru'): string => {
        return this.creditTexts
            .filter(cr => cr.language === language)
            .map(cr => cr.text).join(" | ");
    }
}